import React from "react";
import MCE from "../mce";
import $ from "jquery";
// import parse from "html-react-parser";

var HtmlToReact = require("html-to-react");
var ReactDOMServer = require("react-dom/server");
var HtmlToReactParser = require("../react-html/parser");
var htmlToReactParser = new HtmlToReactParser();

const parseHTMLInput = (htmlInput, dragging) => {
  var isValidNode = function () {
    return true;
  };
  var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

  var itemArray = [];
  // Order matters. Instructions are processed in
  // the order they're defined
  var processingInstructions = [
    {
      // This is REQUIRED, it tells the parser
      // that we want to insert our React
      // component as a child
      replaceChildren: true,
      shouldProcessNode: function (node) {
        if (node.type === "comment") {
          return true;
        }
        if (node.attribs && node.attribs["data-letter-section"]) {
          return true;
        }
        if (node.name === "section") {
          return true;
        }
        if (node.attribs && node.attribs["data-letter-element"]) {
          return true;
        }
      },
      processNode: function (node, children, index) {
        // return <div key={index}>{children}</div>
        if (node.type === "comment") {
          //this must be a TR so it doesn't get stripeed by jquery
          return (
            <comment
              className="wrapped-comment"
              style={{ display: "none" }}
              dangerouslySetInnerHTML={{ __html: `<!-- ${node.data} -->` }}
            />
          );
          // return React.createElement('h1', {key: index,}, 'Heading');
        }
        if (node.type === "tag") {
          if (
            node.attribs["data-letter-element"] &&
            node.attribs["data-letter-element"] !== "image"
          ) {
            var randLetter = String.fromCharCode(
              65 + Math.floor(Math.random() * 26)
            );
            var uniqid = randLetter + Date.now();
            return (
              // <div
              //   dangerouslySetInnerHTML={{
              //     __html: ReactDOMServer.renderToString(children)
              //   }}
              // />
              <MCE
                // papa={that.props.papa}
                // ref={(el) => mceRefs.current.push(el)}
                dragging={dragging}
                id={"tiny-react_" + uniqid}
                initialValue={ReactDOMServer.renderToString(children)}
                selector={`[data-letter-element="${node.attribs["data-letter-element"]}"]`}
              />
            );
          }
          if (node.name === "section") {
            var randLetterSection = String.fromCharCode(
              65 + Math.floor(Math.random() * 26)
            );

            // for(var x=0;x<children.length;x++){}

            itemArray.push({
              id: `item-${index}-${randLetterSection}`,
              index: index,
              component: children,
              // sectionType: node.attribs["data-letter-section"],
              nodeName: node.name
              // content: <tbody data-letter_section={index}>{children}</tbody>
            });
            return <div key={index}>{children}</div>;
          }
        }
      }
    },
    {
      // Anything else
      shouldProcessNode: function (node) {
        return true;
      },
      processNode: processNodeDefinitions.processDefaultNode
    }
  ];
  var code = htmlInput;

  /**
   * This fixes the issue when nested sections exist
   * nesting [data-letter-section] tags breaks the drag and drop logic
   * so when there's a nested one, we remove the nested one and
   * the most outer letter-section is the draggable one
   *
   * It adds a div wrapper around the draggable section!
   */
  var div = document.createElement("div");
  div.innerHTML = code;

  //get the outer wrapper
  var clone = $(code).clone(true);
  var $wrapper = $(clone).find("body>div");

  var mhlt = $wrapper.get()[0];
  // if (mhlt) {
  //   console.log(mhlt.innerHTML);
  // }
  // console.log(div.innerHTML);
  // console.log(code)
  // if (mjmlCode) {
  //   code = mjml2html(mjmlCode, {});
  // }

  /**
   * Parse the html to create the react coponent
   */
  if (mhlt) {
    var reactComponent = htmlToReactParser.parseWithInstructions(
      mhlt.innerHTML, //innerHTML is the table within the wrapper we added above
      isValidNode,
      processingInstructions
    );
  }
  if (reactComponent) {
    return { itemArray, reactComponent };
  } else {
    return { itemArray, reactComponent: "" };
  }
};

export default parseHTMLInput;
